import { IconName } from "../Icon";
import * as Color from "../Color";

/**
 * A message appearance.
 */
export interface MessageAppearance {

  /**
   * The message icon.
   */
  readonly icon: IconName;

  /**
   * The message background color.
   */
  readonly backgroundColor: Color.RgbColor;

  /**
   * The message border color. If not specified defaults to the background color.
   */
  readonly borderColor?: Color.RgbColor;

  /**
   * The message foreground color.
   */
  readonly foregroundColor?: Color.RgbColor;

  /**
   * The message icon color.
   */
  readonly iconColor: Color.RgbColor;
}

/**
 * The set of message types.
 */
export interface MessageTypes {

  /**
   * The informational message variant.
   */
  readonly Informational: MessageAppearance;

  /**
   * The error message variant.
   */
  readonly Error: MessageAppearance;

  /**
   * The warning message variant.
   */
  readonly Warning: MessageAppearance;

  /**
   * The success message variant.
   */
  readonly Success: MessageAppearance;
}

/**
 * The set of available message types.
 */
export const Messages: MessageTypes = {
  Informational: {
    icon: "info-circle",
    backgroundColor: Color.Turqoise[50],
    borderColor: Color.Turqoise[200],
    iconColor: Color.Turqoise[500],
  },
  Error: {
    icon: "x-circle",
    backgroundColor: Color.Red[50],
    borderColor: Color.Red[200],
    iconColor: Color.Red[500],
  },
  Warning: {
    icon: "warning-circle",
    backgroundColor: Color.Yellow[50],
    borderColor: Color.Yellow[300],
    iconColor: Color.Yellow[700],
  },
  Success: {
    icon: "check-circle",
    backgroundColor: Color.Green[50],
    borderColor: Color.Green[200],
    iconColor: Color.Green[600],
  },
};
